export default __webpack_public_path__ + "static/media/b5.6843cf33.svg";